import { render, staticRenderFns } from "./ResidentLeave.vue?vue&type=template&id=6f0783ff&scoped=true"
import script from "./ResidentLeave.vue?vue&type=script&lang=js"
export * from "./ResidentLeave.vue?vue&type=script&lang=js"
import style0 from "./ResidentLeave.vue?vue&type=style&index=0&id=6f0783ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0783ff",
  null
  
)

export default component.exports